export default __webpack_public_path__ + "static/media/04AxeLourd60s.4b909c4f.mp3";